<template id="cmsForm">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item">
          <a href="/delivery-history">delivery history</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          delivery history form
        </li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-10">
        <h3>
          ฟอร์ม <span v-if="item_id">แก้ไขประวัติการจัดส่ง</span
          ><span v-if="!item_id">เพิ่มประวัติการจัดส่งใหม่</span>
          <span class="text text-secondary">#{{ erp_order_id }}</span>          
        </h3>
      </div>
    </div>
    <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="formFileLg" class="form-label">image url</label>
                  <input
                    id="delivery_image_url"
                    type="text"
                    class="form-control p-0 m-0"
                    :readonly="true"
                    v-model="form.delivery_image_url"
                  />                  
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <form-error
                  :isError="validateError.delivery_image_url.error"
                  :errorMessage="validateError.delivery_image_url.message"
                ></form-error>
              </div>
            </div>
          </div>
        </div>
    <div class="row">      
      <!-- display image in delivery_image_url -->
      <div class="col-md-5">
        <img :src="delivery_image_url" class="img-thumbnail" alt="" 
          style="width: 300px; height: 540px; object-fit: cover;"
        />
      </div>
      <div class="col-md-7">
        <div class="row">
          <div class="form-group col-md-12">
            <label for="status">สถานะ</label>
            <select id="status" class="form-control" v-model="form.status">
              <option value="draft">draft</option>
              <option value="published">published</option>
            </select>
            <form-error
              :isError="validateError.status.error"
              :errorMessage="validateError.status.message"
            ></form-error>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-12">
            <label for="rating">คะแนนรีวิว</label>
            <select id="rating" class="form-control" v-model="form.rating">
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
            <form-error
              :isError="validateError.rating.error"
              :errorMessage="validateError.rating.message"
            ></form-error>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-12">
            <label for="customer_name">ชื่อลูกค้า</label>
            <input
              id="customer_name"
              type="text"
              class="form-control"
              v-model="form.customer_name"
            />
            <form-error
              :isError="validateError.customer_name.error"
              :errorMessage="validateError.customer_name.message"
            ></form-error>
          </div>
        </div>

        <!-- <div class="row">
          <div class="form-group col-md-12">
            <label for="eng_review_message">รีวิวภาษาอังกฤษ</label>
            <input
              id="eng_review_message"
              type="text"
              class="form-control"
              v-model="form.eng_review_message"
            />
            <form-error
              :isError="validateError.eng_review_message.error"
              :errorMessage="validateError.eng_review_message.message"
            ></form-error>
          </div>
        </div> -->

        <div class="row">
          <div class="form-group col-md-12">
            <label for="tha_review_message">ข้อความรีวิว</label>
            <textarea
              id="tha_review_message"
              type="text"
              class="form-control"
              placeholder="รีวิวของลูกค้า ไม่เกิน 255 ตัวอักษร"
              maxlength="255"
              rows="8"
              v-model="form.tha_review_message"
            />
            <form-error
              :isError="validateError.tha_review_message.error"
              :errorMessage="validateError.tha_review_message.message"
            ></form-error>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-12">            
            <input
              id="show_customer_name"
              type="checkbox"              
              v-model="form.show_customer_name"
            />
            <label for="show_customer_name">แสดงชื่อลูกค้า</label>
            <form-error
              :isError="validateError.show_customer_name.error"
              :errorMessage="validateError.show_customer_name.message"
            ></form-error>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="float-right" v-if="isSaving">
              <!-- show loading -->
              <general-loading></general-loading>
            </div>
            <div class="float-right" v-if="isSavingError">
              <!-- show loading -->
              <span class="text-danger">ไม่สามารถบันทึกได้</span>
            </div>
            <div class="float-right" v-if="isSaved">
              <!-- show loading -->
              <span class="text-success">บันทึกข้อมูลแล้ว</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group float-right">
              <a
                href="javascript:void(0)"
                onclick="javascript:window.history.back(); return false;"
                class="btn btn-secondary"
                >ยกเลิก</a
              >
              <button
                type="button"
                class="btn btn-primary ml-5"
                @click="saveWithGoBack()"
              >
                บันทึก
              </button>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item_id: "",
    delivery_image_url: {
      type: String,
      default: "",
    },
    erp_order_id: {
      type: Number,
      default: null,
    },
    status: {
      type: String,
      default: "draft",
    },
    rating: {
      type: String,
      default: null,
    },
    customer_name: {
      type: String,
      default: "",
    },
    eng_review_message: {
      type: String,
      default: "",
    },
    tha_review_message: {
      type: String,
      default: "",
    },
    show_customer_name: {
      type: Boolean,
      default: false,
    },
    actual_delivery_date: {
      type: String,
      default: "",
    },
    actual_delivery_time: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        delivery_image_url: "",
        erp_order_id: "",
        status: "",
        rating: "",
        customer_name: "",
        eng_review_message: "",
        tha_review_message: "",
        show_customer_name: "",
        erp_delivery_datetime: "",        
      },
      validateError: {
        // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
        delivery_image_url: { error: false, message: "" },
        erp_order_id: { error: false, message: "" },
        status: { error: false, message: "" },
        rating: { error: false, message: "" },
        customer_name: { error: false, message: "" },
        eng_review_message: { error: false, message: "" },
        tha_review_message: { error: false, message: "" },
        show_customer_name: { error: false, message: "" },        
      },
      languages: {
        // เอาไว้เก็บตัวเลือกภาษาใน form select language โดย method fetchLanguages จะไปดึงมาให้จาก laravel
      },
      base_url: "/delivery-history", // base url (เปลี่ยน)
      previewImage: null, //เอาไว้เก็บ preview ของภาพ ก่อนอัพโหลด
      fileInfos: {
        type: "",
        size: "",
        name: "",
      },

      isSaved: false,
      isSaving: false,
      isSavingError: false,
    };
  },
  mounted() {},
  beforeMount() {},
  created() {
    this.form.delivery_image_url = this.delivery_image_url;
    this.form.erp_order_id = this.erp_order_id;
    this.form.status = this.status;
    this.form.rating = this.rating;
    this.form.customer_name = this.customer_name;
    this.form.eng_review_message = this.eng_review_message;
    this.form.tha_review_message = this.tha_review_message;
    this.form.show_customer_name = this.show_customer_name;
    this.form.erp_delivery_datetime = this.actual_delivery_date+" "+this.actual_delivery_time;
  },
  methods: {
    saveWithGoBack() {
      this.save("");
    },
    saveWithMore() {
      this.save("more");
    },
    inputFileChanged() {
      console.log("file change");
      let input = this.$refs.file;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
        console.log(file[0]);
        this.fileInfos.name = file[0].name;
        this.fileInfos.type = file[0].type;
        this.fileInfos.size = file[0].size.toLocaleString() + " Bytes";
      }
    },
    save() {
      let save_url = "";
      let formData = new FormData();
      save_url = this.base_url + "/";
      if (this.item_id) {
        save_url = this.base_url + "/" + this.item_id + "/update";
      } 
      let me = this;
      console.log(this.form);
      
      formData.append("delivery_image_url", this.form.delivery_image_url);
      formData.append("erp_order_id", this.form.erp_order_id);
      formData.append("status", this.form.status);
      formData.append("rating", this.form.rating);
      formData.append("customer_name", this.form.customer_name);
      formData.append("eng_review_message", this.form.eng_review_message);
      formData.append("tha_review_message", this.form.tha_review_message);
      formData.append("show_customer_name", this.form.show_customer_name);
      formData.append("erp_delivery_datetime", this.form.erp_delivery_datetime);  
      // reset error message
      this.validateError.delivery_image_url.error = false;
      this.validateError.erp_order_id.error = false;
      this.validateError.status.error = false;
      this.validateError.rating.error = false;
      this.validateError.customer_name.error = false;
      this.validateError.eng_review_message.error = false;
      this.validateError.tha_review_message.error = false;
      this.validateError.show_customer_name.error = false;    

      this.isSaved = false;
      this.isSaving = true;
      this.isSavingError = false;

      axios
        .post(save_url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          console.log(response);         
          this.item_id = response.data._infos.post_id;
          this.isSaved = true;
          this.isSavingError = false;
        })
        .catch((errors) => {
          this.isSavingError = true;
          if (errors.response.data.message) {
            let errorMessage = errors.response.data.message;
            let fields = Object.keys(this.form);
            fields.forEach(function (item) {
              // console.log(item);
              if (typeof errorMessage[item] != "undefined") {
                me.validateError[item].error = true;
                me.validateError[item].message = errorMessage[item][0];
              }
            });
          } else {
            // console.log(errors.response.data._infos.result);
            // console.log(errors.response.data);
            // alert("ไม่สามารถบันทึกได้" + errors.response.data);
          }
        }).finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>
